import { useCallback, useEffect, useState } from "react";
import { fetchSession, logout as logoutRequest } from "@/api/client";
export type AuthState =
  | {
      status: "checking";
    }
  | {
      status: "signed-out";
    }
  | {
      status: "signed-in";
      isLiveAuthorized: boolean;
    };
export function useAuth() {
  const [auth, setAuth] = useState<AuthState>({ status: "checking" });
  const refresh = useCallback(async () => {
    try {
      const session = await fetchSession();
      if (session.authenticated) {
        setAuth({ status: "signed-in", isLiveAuthorized: session.isLiveAuthorized ?? false });
      } else {
        setAuth({ status: "signed-out" });
      }
    } catch {
      setAuth({ status: "signed-out" });
    }
  }, []);
  useEffect(() => {
    void refresh();
  }, [refresh]);
  const logout = useCallback(async () => {
    await logoutRequest().catch(() => undefined);
    setAuth({ status: "signed-out" });
  }, []);
  return { auth, setAuth, refresh, logout };
}
